<div class="container-fluid transport_association_page">
	<div class="col-md-12" *ngIf="isLoading">
		<app-busy [message]="message"></app-busy>
	</div>
	<div class="section_header">
		<h1 class="heading">
			<i class="fa fa-edit"></i>
			Transport Association:
			<strong>{{lblHeading}}</strong>
		</h1>
	</div>

	<form [formGroup]="form" (ngSubmit)="onSubmit(form.value)">
		<div class="row">
			<div class="col-6">
				<div class="form_field">
					<label class="control-label">
						Transport Association Code<span class="red-asterik">*</span>
						<span *ngIf="isDup" class="text-danger">Duplicate Codes are not allowed</span>
					</label>
					<div class="form-control-group">
						<input type="text" name="code" formControlName="code" class="form-control"
							[ngClass]="{'error':form.controls.code.invalid && form.controls.code.dirty, 'noerror': form.controls.code.valid && form.controls.code.dirty}"
							title="Codes must be unique. Main sort order if group_code and sort_order not used." />
						<div class="form-control-feedback text-danger text-small"
							*ngIf="form.controls.code.invalid && form.controls.code.dirty">
							<p *ngIf="form.controls.code.errors.required">Code is required</p>
							<p *ngIf="form.controls.code.errors.maxlength">Code must not be more than 12
								characters.</p>
						</div>
					</div>
				</div>

				<div class="form_field">
					<label class="control-label">
						Cellphone<span class="red-asterik">*</span>
					</label>
					<div class="form-control-group">
						<ngx-intl-tel-input [cssClass]="'form-control'" [preferredCountries]="preferredCountries"
							[enableAutoCountrySelect]="true" [enablePlaceholder]="true" [searchCountryFlag]="true"
							[searchCountryField]="[SearchCountryField.Iso2, SearchCountryField.Name]"
							[selectFirstCountry]="false" [maxLength]="15" [tooltipField]="TooltipLabel.Name"
							[phoneValidation]="true" [selectedCountryISO]="defaultCountry"
							[separateDialCode]="separateDialCode" (countryChange)="ChangeCountry($event)"
							name="cellphone" formControlName="cellphone">
						</ngx-intl-tel-input>
						<div class=" col-md-6 form-control-feedback text-danger text-small"
							*ngIf="form.controls.cellphone.invalid && form.controls.cellphone.touched">
							<p class="txt-error">*Invalid</p>
						</div>
					</div>
				</div>
			</div>
			<div class="col-6">
				<div class="form_field">
					<label class="control-label">
						Description<span class="red-asterik">*</span>
					</label>
					<div class="form-control-group">
						<textarea class="form-control" rows="6" name="description" formControlName="description"
							[ngClass]="{'error':form.controls.description.invalid && form.controls.description.dirty, 'noerror': form.controls.description.valid && form.controls.description.dirty}"
							title="Free text description of the entity occurrence."></textarea>
						<div class="form-control-feedback text-danger text-small"
							*ngIf="form.controls.description.invalid && form.controls.description.dirty">
							<p *ngIf="form.controls.description.errors.required">Description is required</p>
							<p *ngIf="form.controls.description.errors.maxlength">Description must not be
								more than 100 characters</p>
						</div>
					</div>
				</div>
			</div>

			<div class="col-6">
				<div class="form_field">
					<label class="control-label">
						Email<span class="red-asterik">*</span>
					</label>
					<input type="email" name="email" formControlName="email" class="form-control input-sm"
						[ngClass]="{'error': form.controls.email.invalid  && form.controls.email.dirty , 'noerror': form.controls.email.valid  && form.controls.email.dirty}" />
					<div class="col-md-6 form-control-feedback text-danger text-small"
						*ngIf="form.controls.email.invalid && form.controls.email.dirty">
						<p *ngIf="form.controls.email.errors.required">*Required</p>
						<p *ngIf="form.controls.email.errors.pattern">*Invalid Email Address!</p>
					</div>
				</div>
			</div>
			<div class="col-6">
				<div class="form_field">
					<label class="control-label">Telephone<span class="red-asterik">*</span>
					</label>
					<ngx-intl-tel-input [cssClass]="'form-control input-sm'" style="width:100%;"
						[preferredCountries]="preferredCountries" [enableAutoCountrySelect]="true"
						[enablePlaceholder]="true" [searchCountryFlag]="true"
						[searchCountryField]="[SearchCountryField.Iso2, SearchCountryField.Name]"
						[selectFirstCountry]="false" [maxLength]="15" [tooltipField]="TooltipLabel.Name"
						[phoneValidation]="true" [selectedCountryISO]="defaultCountryPhone"
						[separateDialCode]="separateDialCode" (countryChange)="ChangeCountryPhone($event)"
						name="telephone" formControlName="telephone">
					</ngx-intl-tel-input>
					<div class="form-control-feedback text-danger text-small"
						*ngIf="form.controls.telephone.invalid && form.controls.telephone.touched">
						<p class="row">*Invalid</p>
					</div>
				</div>
			</div>
			<div class="col-6">
				<div class="form_field">
					<label class="control-label">Alternative Cellphone<span class="red-asterik">*</span></label>
					<input type="text" name="alternative_cellphone" formControlName="alternative_cellphone"
						class="form-control input-sm"
						[ngClass]="{'error': form.controls.alternative_cellphone.invalid  && form.controls.alternative_cellphone.dirty , 'noerror': form.controls.alternative_cellphone.valid  && form.controls.alternative_cellphone.dirty}" />
					<div class="form-control-feedback text-danger text-small"
						*ngIf="form.controls.alternative_cellphone.invalid && form.controls.alternative_cellphone.dirty">
						<p class="row" *ngIf="form.controls.alternative_cellphone.errors.pattern">Invalid
							alternative cellphone number</p>
					</div>
				</div>
			</div>
			<div class="col-6">
				<div class="form_field">
					<label class="control-label">Alternative Email<span class="red-asterik">*</span></label>
					<input type="text" name="alternative_email" formControlName="alternative_email"
						class="form-control input-sm"
						[ngClass]="{'error': form.controls.alternative_email.invalid  && form.controls.alternative_email.dirty , 'noerror': form.controls.alternative_email.valid  && form.controls.alternative_email.dirty}" />
					<div class="col-md-6 form-control-feedback text-danger text-small"
						*ngIf="form.controls.alternative_email.invalid && form.controls.alternative_email.dirty">
						<p *ngIf="form.controls.alternative_email.errors.pattern">*Invalid alternative email
							address!</p>
					</div>
				</div>
			</div>
			<div class="col-12">
				<fieldset class="fieldset-border">
					<legend class="schedule-border">Sorting And Displaying</legend>
					<div class="row">
						<div class="col-md-3">
							<label class="control-label">
								Sort Order<span class="red-asterik">*</span>
							</label>
							<div class="form_field">
								<select id="sort_order" class="form-control" name="sort_order"
									formControlName="sort_order"
									title="Allows user to put in a sorting code. By default, all rows will have sort_order 1.">
									<option *ngFor="let rank of utility.sortOrderList" [ngValue]="rank" [selected]="0">
										{{rank}}</option>
								</select>
							</div>
						</div>
						<div class="col-md-3">
							<label class="control-label">
								Group Code<span class="red-asterik">*</span>
							</label>
							<div class="form_field">
								<input type="text" class="form-control" name="group_code" formControlName="group_code"
									[ngClass]="{'error':form.controls.group_code.invalid && form.controls.group_code.dirty, 'noerror': form.controls.group_code.valid && form.controls.group_code.dirty}"
									title="Allows user to group codes. By default, all rows will belong to group A.">

								<div class="form-control-feedback text-danger text-small"
									*ngIf="form.controls.group_code.invalid && form.controls.group_code.dirty">
									<p *ngIf="form.controls.group_code.errors.required">Group Code is required
									</p>
									<p *ngIf="form.controls.group_code.errors.maxlength">Group Code must not be
										more than 12 characters.</p>
								</div>
							</div>

						</div>
						<div class="col-md-3">
							<label class="control-label">
								Display When<span class="red-asterik">*</span>
							</label>
							<div class="form_field">
								<select class="form-control" id="display_ind" [(ngModel)]="selectedDisplay"
									(change)="onSelectChange()" name="display_ind" formControlName="display_ind"
									title="Indicates where it is used on dropdowns or lists.">
									<option *ngFor="let ind of utility.displayIndicators" [ngValue]="ind.key">
										{{ind.value}}</option>
								</select>
							</div>
						</div>

						<div class="col-md-3">
							<div>
								<label class="control-label">Active?</label>
								<input class="form-control input-sm" type="checkbox" id="is_active" value="is_active"
									formControlName="is_active"
									title="An indicator to control if the row will appear on a list or in a search. Can be used to indicate logically deleted.">
							</div>
						</div>
					</div>
				</fieldset>
				<div class="col-12" style="margin:10px 0;padding:20px 0; font-size:11px;">
					<dl style="width:460px;margin:0px;padding:0px;">
						<dt style="width:40px;">Created</dt>
						<dd [innerHTML]="audit.created"></dd>
						<dt style="width:46px;">Updated</dt>
						<dd [innerHTML]="audit.updated"></dd>
					</dl>
				</div>
			</div>
			<!-- End of Sorting and Displayings -->
		</div>

		<hr>
		<div class="action_btns_wrapper center">
			<div class="btn_wrap">
				<button title="Go Back" type="button" id="btnCancel" [routerLink]="['/transport/association/list']"
					class="btn btn_secondary">
					<i class="fa fa-arrow-circle-left"></i> Back
				</button>
			</div>
			<div class="btn_wrap">
				<button title="Save change(s)" type="submit" id="btnSave" [disabled]="!form.valid"
					class="btn btn_primary">
					<i class="fa fa-save"></i>
					Save
				</button>
			</div>
		</div>
	</form>
</div>